import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'
import {cssTheme} from '@logistics-frontend/blocks/v2'

export const classes = {
  input: css`
    margin: ${spacing(1, 0)};
  `,
  actionButton: css`
    margin: ${spacing(4, 0, 1)};
  `,
  smallRemoveButton: css`
    height: ${spacing(2.5)};
    width: ${spacing(2.5)};
    line-height: 0;
    padding: 0;
    font-weight: ${cssTheme.fonts.weights.bold};
    font-size: ${cssTheme.fonts.sizes.body2};
    cursor: pointer;
  `,
}
